import {AvatarInput} from '@/components/refinedev/AvatarInput';
import TextInput from '@/components/refinedev/TextInput';
import Section from '@/components/surface/Section';
import {defaultMutationOptions} from 'pages/_utils';
import {FormProvider, useForm} from 'react-hook-form';
import TextareaInput from '@/components/refinedev/TextareaInput';
import {SaveButton} from '@/components/refinedev/action_buttons';
import {useApiService} from '@/lib/ApiService';
import {useCallback, useEffect} from 'react';
import Loader from '@/components/Loader';
import {useMutation, useQuery} from '@tanstack/react-query';
import getFormData from '@/lib/getFormData';
import {dirtyValues} from '@/lib/react-hook-form-helpers';
import {ChangeAccountPasswordButton} from './change-password-button';
// import ClassesInUserManager from './classes-in-user-manager';

const ProfilePage = () => {
  const apiService = useApiService();
  const getProfile = useQuery({
    queryKey: ['profile'],
    queryFn: async () => {
      return await apiService.profile.getProfile();
    },
  });
  const data = getProfile?.data;

  const saveProfile = useMutation({
    ...defaultMutationOptions,
    mutationKey: ['profile'],
    mutationFn: async payload => {
      const formdata = getFormData(payload); //multi-part form for upload avatar
      return await apiService.profile.saveProfile(formdata);
    },
    // onSuccess: () => {
    //   document.location.reload();
    // },
  });

  const useFormResults = useForm({});

  useEffect(() => {
    if (!data) return;
    useFormResults.reset(data);
  }, [data]);

  const {handleSubmit} = useFormResults;

  const onSubmit = useCallback(
    async data => {
      console.log('submit', data);
      data = dirtyValues(useFormResults.formState.dirtyFields, data);
      data = transformBeforeSave(data);
      await saveProfile.mutateAsync(data);
    },
    [useFormResults.formState.dirtyFields],
  );

  if (getProfile.isLoading) return <Loader />;

  return (
    <FormProvider {...useFormResults}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ProfileForm />
      </form>
    </FormProvider>
  );
};

const ProfileForm = () => {
  return (
    <div className="w-full flex flex-col flex-wrap gap-y-4 items-center">
      <Section className="w-[28rem]" title="Thông tin cá nhân">
        <AvatarInput source="staff.avatar" label="Ảnh đại diện" />
        <TextInput source="staff.staff_no" label="Số hiệu nhân viên" />
        <TextInput source="staff.name" label="Họ và tên" />
        <TextInput source="staff.mobile" label="Số điện thoại" />
        <TextInput source="staff.email" label="Email" />
        <TextInput source="staff.current_address" label="Địa chỉ" />
        <TextareaInput source="staff.notes" label="Ghi chú" />
        <SaveButton className="mt-2 w-48 self-center" />
      </Section>
      <Section className="w-96" title="Đổi mật khẩu">
        <ChangeAccountPasswordButton className="self-center" />
      </Section>
    </div>
  );
};

const transformBeforeSave = inputData => {
  const data = {
    ...inputData,
    name: inputData.staff.name,
    roles: inputData.roles?.map(r => r.id),
  };
  return data;
};

export default ProfilePage;
